import { db, auth, str } from '@/main'
import slugify from 'slugify'
export const Doc = {
  data() {
    return {
      doc: { hours: {} },
      message: '',
      dob: {},
      name: {}
    }
  },

  watch: {
    doc( curr, prev ) {
      this.$i18n.locale = this.account.locale
    }
  },

  methods: {
    update() {
      if ( this.password.current && this.password.new && this.password.confirm ) {
        auth.signInWithEmailAndPassword( this.user.email, this.password.current )
        .then( doc => {
          this.message = 'Authenticated:  Updating password...'
          if ( this.password.new != this.password.confirm )
            this.message = 'Password and confirmation does not match'
          else
            this.user.updatePassword( this.password.new )
              .then( () => {
                this.message = 'Password updated!'
                this.password = {}
                this.set()
              })
              .catch( e => this.message = e )
        })
        .catch( e => this.message = e )
      }
      else this.set()
    },

    set() {
      let idref = db.collection(this.collection).doc(this.doc.id)
      if ( this.doc.hours.opening > this.doc.hours.closing ) return this.message = 'Oops!  Did you make a mistake?  Cannot set opening time to later than closing time'
      this.doc.dob = this.dob
      this.doc.name = this.name
      idref.set(this.doc).then( async doc => {
        this.message = `${this.type} information saved!`
        this.$binding( 'doc', db.collection(this.collection).doc( current_id ) ).then( () => {
          if (this.$route.params.thanks) this.$router.push({ name: 'dashboard', params: { onboarding: true } })
        })
      })
    },

    upload( e, field ) {
      console.log('uploading...')
      let file = e.target.files[0]
      let ref = str.ref(`/user/${this.user.uid}/avatars/${file.name}`)
      ref.put(file).then( snap => {
        console.log('file put')
        snap.ref.getDownloadURL().then( url => {
          console.log('url retrieved')
          this.user.updateProfile({
            photoURL: url
          }).then( () => this.key++ )
          db.collection( 'accounts' ).doc( this.account.id ).update({
            avatar: url
          }).then( () => this.key++ )
        })
      }).catch( e => console.log(e) )
    }
  },

  created() {
    if ( this.user && this.user.uid ) db.collection( this.collection ).where( 'user_id', '==', this.user.uid ).get().then( snap => {
      if ( snap.docs.length ) this.doc = { ...snap.docs[0].data(), ...{id: snap.docs[0].id} }
    })
  }
}
